var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.7754,
    cy: 50,
    r: 50,
    fill: "#E7F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7754 36H36.7754C34.8504 36 33.2929 37.575 33.2929 39.5L33.2754 60.5C33.2754 62.425 34.8504 64 36.7754 64H64.7754C66.7004 64 68.2754 62.425 68.2754 60.5V39.5C68.2754 37.575 66.7004 36 64.7754 36ZM64.7754 60.5H36.7754V43L50.7754 51.75L64.7754 43V60.5ZM50.7754 48.25L36.7754 39.5H64.7754L50.7754 48.25Z",
    fill: "#005FEA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.8d84aae216752ddea5f6ad3defe8ea98.svg";
export { ForwardRef as ReactComponent };